import * as React from 'react';
import { Box, Button, Modal, Stack, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { ColumnModel } from '@/features/crm/types';
import * as Yup from 'yup';
import { enqueueSnackbar } from 'notistack';
import useLoadingActions from '@/hooks/useLoadingActions.tsx';
import { OccupancyDashboardType } from '@/features/occupancyDashboard/types';
import { changeCapacidadeOccupancy } from '@/features/occupancyDashboard/api/changeCapacidadeOccupancy.ts';
import { useEffect } from 'react';

type PropsType = {
  open: boolean;
  handleClose: () => void;
  submit: () => void;
  rowSelected: any;
  onRefresh: () => void;
};

const RegisterClassCapacityModal: React.FC<PropsType> = ({ onRefresh, open, handleClose, submit, rowSelected }) => {
  const idRegister = rowSelected?.original?.id;
  const { setIsLoading } = useLoadingActions();
  const formik = useFormik<Partial<OccupancyDashboardType>>({
    initialValues: {
      capacidade: 10,
    } as unknown as ColumnModel,
    validationSchema: Yup.object({
      capacidade: Yup.number().required('Campo obrigatório'),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true, 'Adicionando capacidade...');

        await changeCapacidadeOccupancy(idRegister, values.capacidade)

        enqueueSnackbar('Capacidade adicionada com sucesso!', {
          variant: 'success',
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
        });

        onRefresh();
        handleClose();
      } catch (e) {
        enqueueSnackbar((e as Error).message || 'Falha ao adicionar capacidade!', {
          variant: 'error',
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
        });
      } finally {
        setIsLoading(false, '');
      }
    },
  });

  useEffect(() => {
    if (rowSelected) {
      formik.setFieldValue('capacidade', rowSelected.original.total)
    }
  }, [rowSelected]);

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '517px',
    width: '100%',
    bgcolor: '#fff',
    borderRadius: '20px',
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}
             component={'form'}
             noValidate
             onSubmit={formik.handleSubmit}>
          <Box style={{ background: '#93DC3F', borderRadius: '20px 20px 0 0', boxShadow: '0px 4px 4px 0px #00000040' }}>
            <Typography color={'#231F20'} variant="h1" p={'10px 29px'}>
              Cadastrar capacidade das turma
            </Typography>
          </Box>
          <Stack sx={{ p: '20px 30px 50px 30px' }} justifyContent={'center'}>

            <Stack gap={'20px'} flexDirection={'row'} justifyContent={'center'}>
              <Box flex={1}>
                <Box maxWidth={'300px'} margin={'auto'}>
                  <Typography>Quantidade:</Typography>

                  <TextField
                    id="capacidade"
                    name="capacidade"
                    value={formik.values.capacidade}
                    onChange={formik.handleChange}
                    fullWidth
                    type={'number'}
                    placeholder={'10'}
                  />

                </Box>
              </Box>
            </Stack>

            <Stack margin={'auto'} gap={'20px'} flexDirection={'row'}>
              <Button
                sx={{ width: '164px', borderRadius: '24px', fontSize: '14px', mt: '40px', bgcolor: '#D63429' }}
                variant="contained"
                onClick={handleClose}
              >
                Descartar
              </Button>
              <Button
                sx={{ width: '164px', borderRadius: '24px', fontSize: '14px', mt: '40px', bgcolor: '#15AB51' }}
                variant="contained"
                type={"submit"}
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default RegisterClassCapacityModal;
